export default {
  actions: {
    LOGGED_IN: ['Logged In', {
      category: 'Account', label: 'widget', flow: 'sms',
    }],
    SIGNED_UP: ['Signed Up', {
      category: 'Account', label: 'widget', flow: 'sms',
    }],
  },
};
